<template>
  <div id="presented">
    <div class="inner">
      <el-row class="title"  style="border-bottom:dashed 1px rgba(151,151,151,0.5);padding-bottom:8px;">
        <el-col :span="20">
          <div class="grid-content bg-purple-dark box-title">{{$store.state.name}}转赠</div>
          <div></div>
        </el-col>
        <el-col :span="4" style="text-align:right;">
          <div
            class="grid-content bg-purple-dark ft15"
            style="font-weight:400;line-height:40px;display: inline-block;"
          >
            <span>
              <router-link style="font-size: 13px;font-family: MicrosoftYaHei;color: #7A7A7A;" :to="{name:'Mypoints'}">{{$store.state.name}}转赠记录</router-link>
            </span>
            <i class="el-icon-arrow-right"></i>
          </div>
        </el-col>
      </el-row>
      <div class="g-box" v-show="step==1">
        <div class="inputbox" style="margin:0px 0 20px 0;">
          <input type="text" v-model="account" placeholder="请输入对方账号" />
        </div>
        <div class="inputbox">
          <input type="text" v-model="integral" placeholder="请输入要转赠的积分" />
        </div>
        <p
          style="margin:10px 5px 20px 5px;"
          class="ft12"
        >你目前可转出的{{$store.state.name}}为：{{$store.state.userinfo.point}}</p>
        <button class="theme-bg ft14" @click="checkAccount()">下一步</button>
      </div>
      <div class="g-box" v-show="step==2">
        <div class="inputbox" style="margin:0px 0 20px 0;">
          <input type="password" v-model="password" class="ft13" placeholder="请输入您的登录密码" />
        </div>
        <div class="yzm-box clearfloat">
          <div class="inputbox" style="width: 152px;display: inline-block;float:left;">
            <input type="text" v-model="loginCode" class="ft13" placeholder="请输入验证码" />
          </div>
          <div class="yzm" @click="refreshCode">
            <s-identify :identifyCode="identifyCode" :contentWidth="96" :contentHeight="48" style="height:48px;"></s-identify>
          </div>
        </div>
        <div
          class="inputbox theme-bg"
          style="color:#fff;display: inline-block;line-height: 38px;text-align: center;margin-top: 20px"
          @click="presented()"
        >立即转赠</div>
      </div>
      <div class="buysuccess" v-if="step==3">
         <div class="" style="padding-top:90px;text-align:center;margin-bottom:14px;"><img src="/static/img/sucess.png"  style="width:44px;" /></div>

        <p style="margin-bottom:18px;height: 40px;font-size: 24px;font-family: MicrosoftYaHei;color: #262626;line-height: 40px;">
          <!-- <i class="el-icon-circle-check theme-col"></i> -->
          &nbsp;恭喜您，{{$store.state.name}}转赠成功！
        </p>
        <div class="buysuccess-text">
        <p style="">对方账号：{{resultAccount}}</p>
        <p>转出{{$store.state.name}}：{{resultPoint}}{{$store.state.name}}</p>
        <p>转赠时间：{{resultTime}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SIdentify from "@/common/identify";
export default {
  data() {
    return {
      step: 1,
      account: "", //转增账号
      integral: "", //转增积分
      password: "",
      identifyCodes: "1234567890",
      identifyCode: "",
      loginCode: "",
      resultTime: "",
      resultAccount: "",
      resultPoint: ""
    };
  },
  components: {
    SIdentify
  },
  watch: {
    integral(val) {
      this.integral = this.integral.replace(/[^\d]+|(^0)+/g, "");
    }
  },
  methods: {
    times: function(timestamp) {
      var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() + " ";
      var h = date.getHours() + ":";
      var m;
      if (date.getMinutes() < 10) {
        m = "0" + date.getMinutes() + ":";
      } else {
        m = date.getMinutes() + ":";
      }
      var s;
      if (date.getSeconds() < 10) {
        s = "0" + date.getSeconds();
      } else {
        s = date.getSeconds();
      }
      return Y + M + D + h + m + s;
    },
    //生成验证码
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    //生成验证码
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    },
    //生成验证码
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    checkAccount() {
      if (this.account == null || this.account == "") {
        this.$message({
          message: "请输入对方账号",
          duration: 1500,
          center: true
        });
        return;
      }
      if (this.integral == null || this.integral == "") {
        this.$message({
          message: "请输入要转赠的积分",
          duration: 1500,
          center: true
        });
        return;
      }
      this.$api.get(
        "user/point/transfer",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id,
          account: this.account,
          point: this.integral,
          pwd_user: ""
        },
        res => {
          if (res.data.message !== "密码错误") {
            this.$message({
              message: res.data.message,
              duration: 1500,
              center: true
            });
          } else {
            // this.$router.push{name:1}
            this.step = 2;
          }
        }
      );
    },
    presented() {
      if (this.loginCode !== this.identifyCode) {
        this.$message({
          message: "验证码错误，请重新输入",
          duration: 1500,
          center: true
        });
        return;
      }
      this.$confirm(
        "您将转赠" +
          this.integral +
          this.$store.state.name +
          "给用户:" +
          this.account +
          "",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          this.$api.get(
            "user/point/transfer",
            {
              id_example: this.$store.state.id_example,
              token_user: this.$store.state.user_id,
              account: this.account,
              point: this.integral,
              pwd_user: this.password
            },
            res => {
              if (res.data.code == -100) {
                this.$message({
                  message: res.data.message,
                  duration: 1500,
                  center: true
                });
              } else {
                this.step = 3;
                this.resultAccount = res.data.data.account;
                this.resultPoint = res.data.data.point;
                this.resultTime = this.times(res.data.data.time);
                this.$store.commit("userInfo");
              }
            }
          );
        })
        .catch(() => {});
    }
  },
  mounted() {
    this.step = 1;
    this.refreshCode();
    this.$store.commit("userInfo");
  }
};
</script>
<style lang="less" scoped>
.buysuccess-text{
  p{
        color: rgb(122, 122, 122);
    font-size: 13px;

    line-height: 28px;
  }
}
.g-box{
  width: 262px;
    margin: 0 auto;
    margin-top: 60px;
}
  .box-title{
    height: 40px;
font-size: 24px;
font-family: MicrosoftYaHei;
color: #262626;
line-height: 40px;
  }
#presented {
  width: 985px;
  min-height: 572px;
  float: left;
  background: #fff;
  box-shadow: 0px 9px 13px 0px rgba(190, 190, 190, 0.2);
  .inner {
    box-sizing: border-box;
    padding: 10px 30px;
    .inputbox {
      // margin: 40px;

      input {
        width: 100%;
        width: 100%;
      height: 52px;
      border: 1px solid rgba(230, 231, 231, 1);
      padding: 0 15px;
      box-sizing: border-box;
        &:hover{
        border:solid 1px #b8bfc9;
      }
      &:focus,&:active{
         border:solid 1px #E23130!important;
      }
      }
    }
    .yzm-box {
      height: 48px;
    }
    .yzm {
      width: 100px;
      height: 48px;
      float: left;
      margin-left: 10px;
    }
    button {
      width: 100%;
      height: 48px;
background: #E23130;
border-radius: 6px;
border: 1px solid #E23130;
      text-align: center;
    }
  }
  .handleNav {
    height: 40px;
    background: #e3e3e3;
    border: 1px solid #ddd;
    margin-top: 55px;
    span {
      display: inline-block;
      height: 40px;
      line-height: 40px;
      text-align: center;
    }
    .name1 {
      width: 370px;
      margin-left: 20px;
      text-align: left;
    }
    .name2 {
      width: 240px;
    }
    .name3 {
      width: 270px;
    }
  }
  .buysuccess {
    width: 280px;
    position: relative;
    margin: 0 auto;
    p {

      text-align: center;
      // color: #353535;
       font-size: 13px;
font-family: MicrosoftYaHei;
color: #7A7A7A;
margin-top: 0px;
line-height: 28px;
    }
    // p:first-child {
    //   padding-left: 0px;
    //   color: #000;
    // }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/cont/presented.vue